import Collection from "../../data-structures/collection";
import Template from "./template";
import {TemplateType} from "./@const";


export class TemplatesCollection extends Collection<Template> {

    constructor(models: Template[]) {
        super(models);
    }

    static initFromJson(data: any): TemplatesCollection {

        const models: Template[] = []

        _.map(data, (record: JSONObject) => {
            models.push(new Template(record))
        })

        return new TemplatesCollection(models)
    }

    get dashboards(): Template[] {
        return _.filter(this.models, (template: Template) => {
            return (
                (
                    // dashboards only
                    template.type === TemplateType.DASHBOARD_PROJECT
                    || template.type === TemplateType.DASHBOARD_CUSTOM
                )
                && template.acl.hasAccess
            )
        })
    }

    get projectDashboards(): Template[] {
        return _.filter(this.models, (template: Template) => {
            return template.type === TemplateType.DASHBOARD_PROJECT && template.acl.hasAccess
        })
    }

    get customDashboards(): Template[] {
        return _.filter(this.models, (template: Template) => {
            return template.type === TemplateType.DASHBOARD_CUSTOM && template.acl.hasAccess
        })
    }

    toOptions(): Option[] {
        return _.map(this.models, (office: Template) => {
            return office.toOption()
        }) as Option[]

    }

}
